import { useEffect, useState } from 'react';
import {
  Grid,
  TextField,
  Button,
  Typography,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Box,
  Divider
} from '@mui/material';

// import { Person } from '../../schema/person';
import { Person, PersonInfo, PersonStatus } from '../../schema/person';

import { Area } from '../../schema/area';
import { GateGroup } from '../../schema/gate';
import { Form } from '../../pages/AdminSetting/SystemManagement';
import { api } from '../../api';

interface InoutInfoProps {
  person_id?: string | number;
  editable?: boolean;
}

const InoutInfo: React.FC<InoutInfoProps> = ({ person_id, editable }: InoutInfoProps) => {
  // const [isActive, setIsActive] = useState<boolean>(false);

  // const [isOLRActive, setIsOLRActive] = useState<boolean>(false);
  // const [isOLRTempActive, setIsOLRTempActive] = useState<boolean>(false);

  // const [isWPMActive, setIsWPMActive] = useState<boolean>(false);
  // const [isWPMTempActive, setIsWPMTempActive] = useState<boolean>(false);

  // const [isOSTActive, setIsOSTActive] = useState<boolean>(false);
  // const [isOSTTempActive, setIsOSTTempActive] = useState<boolean>(false);

  // const [isCVAActive, setIsCVAActive] = useState<boolean>(true);
  // const [isCVATempActive, setIsCVATempActive] = useState<boolean>(true);

  // const [isHealthActive, setIsHealthActive] = useState<boolean>(true);
  // const [isHealthTempActive, setIsHealthTempActive] = useState<boolean>(true);

  const [personStatus, setPersonStatus] = useState<PersonStatus | null>(null);

  const [isOpenSuccessDialog, setIsOpenSuccessDialog] = useState<boolean>(false);

  const [exchangeData, setExchangeData] = useState<PersonInfo | null>(null);

  // General and Office area
  const [personAreasGnO, setPersonAreasGnO] = useState<Area[]>([]);
  const [personAreasC, setPersonAreasC] = useState<Area[]>([]);

  // Permanant permit area
  const [personAreasPPGnO, setPersonAreasPPGnO] = useState<Area[]>([]);
  const [personAreasPPC, setPersonAreasPPC] = useState<Area[]>([]);
  // Temporary permit area
  const [personAreasTPGnO, setPersonAreasTPGnO] = useState<Area[]>([]);
  const [personAreasTPC, setPersonAreasTPC] = useState<Area[]>([]);

  const [isActive, setIsActive] = useState<boolean>(false);

  const [personGateGroupPP, setPersonGateGroupPP] = useState<GateGroup[]>([]);
  const [GateGroupPP, setGateGroupPP] = useState<GateGroup[]>([]);

  const [personGateGroupTP, setPersonGateGroupTP] = useState<GateGroup[]>([]);
  const [GateGroupTP, setGateGroupTP] = useState<GateGroup[]>([]);

  const [areas, setAreas] = useState<Area[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const openSuccessDialog = () => {
    setIsOpenSuccessDialog(true);
    setTimeout(() => {
      setIsOpenSuccessDialog(false);
    }, 1000);
  };
  const fetchData = () => {
    if (person_id) {
      api.get<Person>(`/person/${person_id}`).then((res) => {
        const { data } = res;
        setPersonStatus(data);
        setIsActive(data.is_active);
      });
      api
        .get<Area[]>(`/person/${person_id}/area/extra`, { params: { is_temporary: false } })
        .then((res) => {
          const { data } = res;
          setPersonAreasPPGnO(data.filter((data) => data.is_require_wpm == false));
          setPersonAreasPPC(data.filter((data) => data.is_require_wpm == true));
        });
      api
        .get<Area[]>(`/person/${person_id}/area/extra`, { params: { is_temporary: true } })
        .then((res) => {
          const { data } = res;
          setPersonAreasTPGnO(data.filter((data) => data.is_require_wpm == false));
          setPersonAreasTPC(data.filter((data) => data.is_require_wpm == true));
        });
      api.get<Area[]>(`/person/${person_id}/area`).then((res) => {
        const { data } = res;
        setPersonAreasGnO(data.filter((data) => data.is_require_wpm !== true));
        setPersonAreasC(data.filter((data) => data.is_require_wpm === true));
      });

      api
        .get<GateGroup[]>(`person/${person_id}/gategroup`, { params: { is_temporary: false } })
        .then((res) => {
          const { data } = res;
          setPersonGateGroupPP(data);
        });
      api
        .get<GateGroup[]>(`person/${person_id}/gategroup`, { params: { is_temporary: true } })
        .then((res) => {
          const { data } = res;
          setPersonGateGroupTP(data);
        });
    }
  };

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (isLoading) {
      return;
    }
    if (person_id) {
      setIsLoading(true);
      api
        .post(`/person/${person_id}/inout`, {
          is_active: isActive,
          permanent_areas: [
            ...personAreasPPGnO.map((data) => data.id),
            ...personAreasPPC.map((data) => data.id)
          ],
          temporary_areas: [
            ...personAreasTPGnO.map((data) => data.id),
            ...personAreasTPC.map((data) => data.id)
          ],
          permanent_gategroup: personGateGroupPP.map((data) => data.id),
          temporary_gategroup: personGateGroupTP.map((data) => data.id)
        })
        .then(() => {
          openSuccessDialog();
          fetchData();
        })
        .finally(() => setIsLoading(false));
    }
  };

  useEffect(() => {
    if (person_id) {
      api.get<Person>(`/person/${person_id}`).then((res) => {
        const { data } = res;
        setPersonStatus(data);
      });
      // api.get(`/person/${person_id}/olr/status`).then((res) => {
      //   const { data } = res;
      //   setIsOLRActive(data.is_active);
      //   setIsOLRTempActive(data.is_temp_active);
      // });
      // api.get(`/person/${person_id}/wpm/status`).then((res) => {
      //   const { data } = res;
      //   setIsWPMActive(data.is_active);
      //   setIsWPMTempActive(data.is_temp_active);
      // });
      // api.get(`person/${person_id}/ost/status`).then((res) => {
      //   const { data } = res;
      //   setIsOSTActive(data.is_active);
      //   setIsOSTTempActive(data.is_temp_active);
      // });
      // api.get(`person/${person_id}/cva/status`).then((res) => {
      //   const { data } = res;
      //   setIsCVAActive(data.is_active);
      //   setIsCVATempActive(data.is_temp_active);
      // });

      api
        .get<Area[]>(`/person/${person_id}/area/extra`, { params: { is_temporary: false } })
        .then((res) => {
          const { data } = res;
          setPersonAreasPPGnO(data.filter((data) => data.is_require_wpm == false));
          setPersonAreasPPC(data.filter((data) => data.is_require_wpm == true));
        });
      api
        .get<Area[]>(`/person/${person_id}/area/extra`, { params: { is_temporary: true } })
        .then((res) => {
          const { data } = res;
          setPersonAreasTPGnO(data.filter((data) => data.is_require_wpm == false));
          setPersonAreasTPC(data.filter((data) => data.is_require_wpm == true));
        });
      api.get<Area[]>(`/person/${person_id}/area`).then((res) => {
        const { data } = res;
        setPersonAreasGnO(data.filter((data) => data.is_require_wpm !== true));
        setPersonAreasC(data.filter((data) => data.is_require_wpm === true));
      });

      api
        .get<GateGroup[]>(`person/${person_id}/gategroup`, { params: { is_temporary: false } })
        .then((res) => {
          const { data } = res;
          setPersonGateGroupPP(data);
        });
      api
        .get<GateGroup[]>(`person/${person_id}/gategroup`, { params: { is_temporary: true } })
        .then((res) => {
          const { data } = res;
          setPersonGateGroupTP(data);
        });
        
    }
  }, [person_id]);

  useEffect(() => {
    if (person_id) {
      api.get<Area[]>(`/area`).then((res) => {
        const { data } = res;
        setAreas(data);
      });

      api.get(`/exchange-card/person/${person_id}`).then((res) => {
        const { data } = res;
        setExchangeData(data);
      });

      api.get<GateGroup[]>(`/gate-group`).then((res) => {
        const { data } = res;
        setGateGroupPP(data);
        setGateGroupTP(data);
      });
    }
  }, [person_id]);

  return (
    <>
      <Typography variant="h6">พื้นที่อนุญาต</Typography>
      <Box sx={{}}>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6}>
            <Typography variant="subtitle2" mt={3}>
              พื้นที่ทั่วไปและสำนักงาน -{' '}
              <Typography
                variant="subtitle2"
                sx={{ display: 'inline' }}
                color={
                  personStatus?.is_active ? 'success.main' : 'error'
                  // (isOLRActive || isOLRTempActive) && (isCVAActive || isCVATempActive)
                  //   ? 'success.main'
                  //   : 'error'
                }
              >
                {personStatus?.is_active
                  ? personStatus?.is_temp_active
                    ? 'ผ่านโดยเจ้าหน้าที่'
                    : 'ผ่านโดยระบบ'
                  : 'ไม่อนุญาตแลกบัตร'}

                {/* {(isOLRActive || isOLRTempActive) && (isCVAActive || isCVATempActive)
                  ? isOLRTempActive || isCVATempActive
                    ? 'ผ่านโดยเจ้าหน้าที่'
                    : 'ผ่านโดยระบบ'
                  : 'ไม่อนุญาตแลกบัตร'} */}
              </Typography>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2" mt={3}>
              พื้นที่ควบคุม -{' '}
              <Typography
                variant="subtitle2"
                sx={{ display: 'inline' }}
                color={
                  personStatus?.is_control_area_active ? 'success.main' : 'error'
                  // (isOLRActive || isOLRTempActive) &&
                  // (isWPMActive || isWPMTempActive) &&
                  // (isOSTActive || isOSTTempActive) &&
                  // (isCVAActive || isCVATempActive)
                  //   ? 'success.main'
                  //   : 'error'
                }
              >
                {personStatus?.is_control_area_active
                  ? personStatus?.is_control_area_temp_active
                    ? 'ผ่านโดยเจ้าหน้าที่'
                    : 'ผ่านโดยระบบ'
                  : 'ไม่อนุญาตแลกบัตร'}
                {/* {(isOLRActive || isOLRTempActive) &&
                (isWPMActive || isWPMTempActive) &&
                (isOSTActive || isOSTTempActive) &&
                (isCVAActive || isCVATempActive)
                  ? isOLRTempActive || isWPMTempActive || isOSTTempActive || isCVATempActive
                    ? 'ผ่านโดยเจ้าหน้าที่'
                    : 'ผ่านโดยระบบ'
                  : 'ไม่อนุญาตแลกบัตร'} */}
              </Typography>
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Autocomplete
              multiple
              disablePortal
              options={personAreasGnO}
              getOptionLabel={(option) => (typeof option != 'string' ? option.area_name : option)}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" label="พื้นที่ทั่วไปและสำนักงาน" />
              )}
              value={personAreasGnO}
              // onChange={(_, value) => setPersonAreasGnO(value)}
              readOnly
              freeSolo
            />
          </Grid>
          <Grid item xs={6}>
            <Autocomplete
              multiple
              disablePortal
              options={personAreasC}
              getOptionLabel={(option) => (typeof option != 'string' ? option.area_name : option)}
              renderInput={(params) => <TextField {...params} label="พื้นที่ควบคุม" />}
              value={personAreasC}
              // onChange={(_, value) => setPersonAreasC(value)}
              readOnly
              freeSolo
            />
          </Grid>
        </Grid>
      </Box>
      <Divider sx={{ mt: 3 }} />
      <Typography variant="h6" mt={3}>
        พื้นที่อนุญาตเพิ่มเติมถาวร
      </Typography>
      <Form onSubmit={handleFormSubmit} sx={{ mt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            {editable ? (
              <Autocomplete
                multiple
                disablePortal
                options={areas.filter((data) => data.is_require_wpm == false)}
                getOptionLabel={(option) => option.area_name}
                renderInput={(params) => <TextField {...params} label="พื้นที่ทั่วไปและสำนักงาน" />}
                value={personAreasPPGnO}
                onChange={(_, value) => setPersonAreasPPGnO(value)}
              />
            ) : (
              <Autocomplete
                multiple
                disablePortal
                options={areas.filter((data) => data.is_require_wpm == false)}
                getOptionLabel={(option) => (typeof option != 'string' ? option.area_name : option)}
                renderInput={(params) => <TextField {...params} label="พื้นที่ทั่วไปและสำนักงาน" />}
                value={personAreasPPGnO}
                readOnly
                freeSolo
              />
            )}
          </Grid>
          <Grid item xs={6}>
            {editable ? (
              <Autocomplete
                multiple
                disablePortal
                options={areas.filter((data) => data.is_require_wpm == true)}
                getOptionLabel={(option) => option.area_name}
                renderInput={(params) => <TextField {...params} label="พื้นที่ควบคุม" />}
                value={personAreasPPC}
                onChange={(_, value) => setPersonAreasPPC(value)}
              />
            ) : (
              <Autocomplete
                multiple
                disablePortal
                options={areas.filter((data) => data.is_require_wpm == true)}
                getOptionLabel={(option) => (typeof option != 'string' ? option.area_name : option)}
                renderInput={(params) => <TextField {...params} label="พื้นที่ควบคุม" />}
                value={personAreasPPC}
                readOnly
                freeSolo
              />
            )}
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" mt={3}>
              พื้นที่อนุญาตเพิ่มเติมชั่วคราว
            </Typography>
          </Grid>
          <Grid item xs={6}>
            {editable ? (
              <Autocomplete
                multiple
                disablePortal
                options={areas.filter((data) => data.is_require_wpm == false)}
                getOptionLabel={(option) => option.area_name}
                renderInput={(params) => <TextField {...params} label="พื้นที่ทั่วไปและสำนักงาน" />}
                value={personAreasTPGnO}
                onChange={(_, value) => setPersonAreasTPGnO(value)}
              />
            ) : (
              <Autocomplete
                multiple
                disablePortal
                options={areas.filter((data) => data.is_require_wpm == false)}
                getOptionLabel={(option) => (typeof option != 'string' ? option.area_name : option)}
                renderInput={(params) => <TextField {...params} label="พื้นที่ทั่วไปและสำนักงาน" />}
                value={personAreasTPGnO}
                readOnly
                freeSolo
              />
            )}
          </Grid>
          <Grid item xs={6}>
            {editable ? (
              <Autocomplete
                multiple
                disablePortal
                options={areas.filter((data) => data.is_require_wpm == true)}
                getOptionLabel={(option) => option.area_name}
                renderInput={(params) => <TextField {...params} label="พื้นที่ควบคุม" />}
                value={personAreasTPC}
                onChange={(_, value) => setPersonAreasTPC(value)}
              />
            ) : (
              <Autocomplete
                multiple
                disablePortal
                options={areas.filter((data) => data.is_require_wpm == true)}
                getOptionLabel={(option) => (typeof option != 'string' ? option.area_name : option)}
                renderInput={(params) => <TextField {...params} label="พื้นที่ควบคุม" />}
                value={personAreasTPC}
                readOnly
                freeSolo
              />
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" mt={3}>
              กลุ่มประตูอนุญาติเพิ่มเติม
            </Typography>
          </Grid>
          <Grid item xs={6}>
            {editable ? (
              <Autocomplete
                multiple
                disablePortal
                options={GateGroupPP}
                getOptionLabel={(option) => option.group_name}
                renderInput={(params) => <TextField {...params} label="กลุ่มประตูอนุญาตถาวร" />}
                value={personGateGroupPP}
                onChange={(_, value) => setPersonGateGroupPP(value)}
              />
            ) : (
              <Autocomplete
                multiple
                disablePortal
                options={GateGroupPP}
                getOptionLabel={(option) => (typeof option != 'string' ? option.group_name : option)}
                renderInput={(params) => <TextField {...params} label="กลุ่มประตูอนุญาตถาวร" />}
                value={personGateGroupPP}
                readOnly
                freeSolo
              />
            )}
          </Grid>
          <Grid item xs={6}>
            {editable ? (
              <Autocomplete
                multiple
                disablePortal
                options={GateGroupTP}
                getOptionLabel={(option) => option.group_name}
                renderInput={(params) => <TextField {...params} label="กลุ่มประตูอนุญาตชั่วคราว" />}
                value={personGateGroupTP}
                onChange={(_, value) => setPersonGateGroupTP(value)}
              />
            ) : (
              <Autocomplete
                multiple
                disablePortal
                options={GateGroupTP}
                getOptionLabel={(option) => (typeof option != 'string' ? option.group_name : option)}
                renderInput={(params) => <TextField {...params} label="กลุ่มประตูอนุญาตชั่วคราว" />}
                value={personGateGroupTP}
                readOnly
                freeSolo
              />
            )}
          </Grid>
          {editable ? (
            <Grid container columns={2} spacing={2} sx={{ mt: 0 }} direction={'row-reverse'}>
              <Grid item>
                <Button type="submit" variant="contained" color="primary">
                  บันทึก
                </Button>
              </Grid>
            </Grid>
          ) : null}
        </Grid>
      </Form>
      <Divider sx={{ mt: 3 }} />
      <Typography variant="h6" mt={3}>
        {exchangeData?.exchange_card_id
          ? 'ข้อมูลแลกบัตรเข้าปัจจุบัน'
          : 'ไม่มีข้อมูลแลกบัตรเข้าในปัจจุบัน'}
      </Typography>
      {exchangeData?.exchange_card_id ? (
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Card ID"
                variant="outlined"
                placeholder="Card ID"
                value={exchangeData?.exchange_card_id ? exchangeData.exchange_card_id : ''}
                InputProps={{ readOnly: true }}
                disabled={!exchangeData?.exchange_card_id}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label="ประเภทบัตรที่แลก"
                variant="outlined"
                placeholder="ประเภทบัตรที่แลก"
                value={
                  exchangeData?.exchange_card_type?.type_name
                    ? exchangeData.exchange_card_type.type_name
                    : ''
                }
                InputProps={{ readOnly: true }}
                disabled={!exchangeData?.exchange_card_type?.type_name}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="เลขอุปกรณ์ติดตามประจำตัว"
                variant="outlined"
                placeholder="เลขอุปกรณ์ติดตามประจำตัว"
                value={exchangeData?.person_gps_id ? exchangeData.person_gps_id : ''}
                InputProps={{ readOnly: true }}
                disabled={!exchangeData?.person_gps_id}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="เลขอุปกรณ์ติดตามยานพาหนะ"
                variant="outlined"
                placeholder="เลขอุปกรณ์ติดตามยานพาหนะ"
                value={exchangeData?.vehicle_gps_id ? exchangeData.vehicle_gps_id : ''}
                InputProps={{ readOnly: true }}
                disabled={!exchangeData?.vehicle_gps_id}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="หมายเลขทะเบียนยานพาหนะ"
                variant="outlined"
                placeholder="หมายเลขทะเบียนยานพาหนะ"
                value={
                  exchangeData?.vehicle_registration_id ? exchangeData.vehicle_registration_id : ''
                }
                InputProps={{ readOnly: true }}
                disabled={!exchangeData?.vehicle_registration_id}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="วัตถุประสงค์"
                variant="outlined"
                placeholder="วัตถุประสงค์"
                value={exchangeData?.reason ? exchangeData.reason : ''}
                InputProps={{ readOnly: true }}
                disabled={!exchangeData?.reason}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="remark"
                variant="outlined"
                placeholder="remark"
                multiline
                minRows={4}
                value={exchangeData?.remark ? exchangeData.remark : ''}
                InputProps={{ readOnly: true }}
                disabled={!exchangeData?.remark}
              />
            </Grid>
          </Grid>
        </Box>
      ) : null}

      <Dialog open={isOpenSuccessDialog} onClose={() => setIsOpenSuccessDialog(false)}>
        <DialogTitle>{'Success'}</DialogTitle>
        <DialogContent>
          <DialogContentText>อัพเดทข้อมูลการตรวจสอบและอัปเดตบุคคลสำเร็จ</DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default InoutInfo;
